import { cn } from "@theprelude/core";
import { ChevronIcon } from "./chevron-icon";

export const RotatingChevron: React.FC<{
  className?: string;
  active: boolean;
}> = ({ className, active }) => (
  <ChevronIcon
    className={cn(
      "rotate-180 transform transition-transform duration-300",
      active && "rotate-0",
      className,
    )}
  />
);
